module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-page-container"
  }, [(_vm.canonicalUrl0) ? _c('link', {
    attrs: {
      "rel": "canonical",
      "href": _vm.canonicalUrl0
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canonicalUrl) ? _c('link', {
    attrs: {
      "rel": "canonical",
      "href": _vm.canonicalUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSizeChartVisible) ? _c('SizeChartModal', {
    attrs: {
      "selectedVariantSize": _vm.selectedProductVariant && _vm.selectedProductVariant.size,
      "sizeChartDetailData": _vm.productWiseSizeChartData,
      "stock": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? [].concat( _vm.commonComboVariantsProd.variant ) : (_vm.selectedComboSizeChart && _vm.selectedComboSizeChart.option && _vm.selectedComboSizeChart.option.variants && [].concat( _vm.selectedComboSizeChart.option.variants )) || [] : [].concat( _vm.product.variant ),
      "productImage": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? [].concat( this.getComboVarientImages(_vm.commonComboVariantsProd.images_new) ) : (_vm.selectedComboSizeChart && _vm.selectedComboSizeChart.variant && this.getComboVarientImages(_vm.selectedComboSizeChart.variant.images_new)) || [] : [].concat( _vm.product.images ),
      "sizeChartTitle": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.category : _vm.selectedComboSizeChart && _vm.selectedComboSizeChart.variant && _vm.selectedComboSizeChart.variant.category : _vm.product.category,
      "prodType": _vm.product.prod_type,
      "sizeChartVisibility": _vm.sizeChartVisibilityHandler,
      "productDetails": _vm.product,
      "isCommonComboVariantProd": _vm.commonComboVariantsProd
    },
    on: {
      "updateVariant": function($event) {
        _vm.updateSizeVariant($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productZoomMobile) ? _c('ProductZoomModal', {
    attrs: {
      "imgArray": _vm.product.images,
      "activeImg": _vm.magActiveimg,
      "videoUrl": _vm.product.video_url,
      "isVideoActive": _vm.product.show_video_url,
      "videoIndex": _vm.product.video_url_index
    },
    on: {
      "closeProdZoomModal": function($event) {
        _vm.closeProductZoomModal($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sizevalid),
      expression: "!sizevalid"
    }],
    staticClass: "pAdded"
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader')], 1) : (_vm.notFound && !_vm.isLoading && _vm.noProductAllowed) ? _c('div', [_c('NoProductFoundListing', {
    attrs: {
      "wishlistItemsIDs": _vm.wishlistItemsIDs,
      "updateWishlist": _vm.updateWishlist
    }
  })], 1) : _c('div', {
    staticClass: "productdetails conbottom"
  }, [(_vm.productSlug === 'bevarsi-kudka-tshirt') ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/bevarsi-banner-desktop.jpg',
      "alt": "bevarsi-kudka-tshirt"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/bevarsi-banner-mobile.jpg',
      "alt": "bevarsi-kudka-tshirt"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bannerName && _vm.productSlug !== 'batman-active-wear-tshirt') ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": _vm.bannerName
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": _vm.bannerName
    }
  })]) : (_vm.productSlug === 'batman-active-wear-tshirt' && _vm.now >= _vm.endDate) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": "batman-active-wear-tshirt"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": "batman-active-wear-tshirt"
    }
  })]) : (_vm.productSlug === 'hourly-deals' && _vm.now >= _vm.endDate) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": "hourly-deals"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": "hourly-deals"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.gifName) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.gifName + '-desktop.jpg',
      "alt": _vm.gifName
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.gifName + '-mobile.jpg',
      "alt": _vm.gifName
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showCountDown && _vm.$parent.isDesktop) ? _c('Countdown', {
    attrs: {
      "starttime": _vm.startDate,
      "endtime": _vm.endDate,
      "color": _vm.timerColor,
      "showTimer": _vm.showTimer,
      "pretext": _vm.liveSaleText,
      "showEarlyText": _vm.showEarlyText
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isExclusive && _vm.showExcBar) ? _c('ExcBand', {
    attrs: {
      "checkedExcBox": _vm.isNotifyVisible,
      "showExcStyle": _vm.excBand.showExcStyle,
      "excBannerMsg": _vm.excBand.excText
    },
    on: {
      "addExc": _vm.addExclusiveToCartFromBand
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.styles,
      "bannerMsg": _vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.styles,
      "bannerMsg": _vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.text
    }
  }) : (_vm.productSlug === 'black-panther-proutility-backpack' && !_vm.isExclusive && !_vm.isSouledOut && _vm.now < _vm.endDate) ? _c('div', {
    staticClass: "text-center exclusive-bar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusiveToCart(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0 pl-4",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.earlyAccessText))])])])]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.now > _vm.startDate && _vm.now < _vm.endDate && !_vm.isExclusive) ? _c('div', {
    staticClass: "text-center exclusive-bar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusive(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0 pl-4",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.earlyAccessText))])])])]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-active-wear-tshirt' && _vm.now < _vm.endDate && _vm.now >= _vm.startDate) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#3498db",
      "color": "#fff",
      "padding": "10px"
    }
  }, [(_vm.now >= _vm.startDate && _vm.now <= _vm.exclusiveDate) ? _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Early Access for Exclusive members opens at 10 AM on " + _vm._s(_vm.formatDate(_vm.exclusiveDate)))]) : (_vm.now >= _vm.exclusiveDate && _vm.isExclusive) ? _c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("Early Access is open for you")]) : (_vm.now >= _vm.exclusiveDate && !_vm.isExclusive) ? _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusive(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Become an member (" + _vm._s(_vm.currencySymbol) + " 199 / year) to Pre-Order this product right now at a " + _vm._s(_vm.currencySymbol) + " 100 discount")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.now >= _vm.exclusiveDate && _vm.now < _vm.endDate && _vm.isExclusive) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "10px",
      "background-color": "rgb(217, 155, 0)"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "#fff"
    }
  }, [_vm._v("\n        Early Access is Now Live\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detailpage details-wrapper fullWidth"
  }, [_c('div', [_c('div', {
    staticClass: "bg-white product-images-conainer",
    class: _vm.productSlug === 'justice-league-reversible-hoodie' && 'prelative'
  }, [_c('div', {
    staticClass: "share-icon",
    on: {
      "click": _vm.shareNavigatorHandler
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/share-icon.svg",
      "alt": "share icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-images-inner"
  }, [(_vm.showCountDown) ? _c('Countdown', {
    attrs: {
      "starttime": _vm.startDate,
      "mobileUI": _vm.$parent.isDesktop ? false : true,
      "isMobilePdp": _vm.$parent.isDesktop ? false : true,
      "endtime": _vm.endDate,
      "color": _vm.timerColor,
      "showTimer": _vm.showTimer,
      "pretext": _vm.liveSaleText,
      "showEarlyText": _vm.showEarlyText
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.images) ? _c('div', {
    class: _vm.showBlur ? 'product-img-blur' : ''
  }, [_c('ProductBanner', {
    attrs: {
      "imgArray": _vm.product.images,
      "activeImg": _vm.magActiveimg,
      "videoUrl": _vm.product.video_url,
      "isVideoActive": _vm.product.show_video_url,
      "videoIndex": _vm.product.video_url_index,
      "isBlur": _vm.product.is_blur
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "product-info-wrapper"
  }, [_c('div', {
    staticClass: "product-title-wrapper bg-white"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "product-title"
  }, [_c('div', [_c('h4', {
    staticClass: "color-grey"
  }, [_c('router-link', {
    staticClass: "op_5",
    attrs: {
      "to": '/explore/' + _vm.product.category_slug
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.product.category) + "\n                      ")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.product.product))]), _vm._v(" "), _c('h5', _vm._l((_vm.product.cat), function(phoneCat) {
    return _c('span', {
      key: phoneCat
    }, [_c('u', [(phoneCat === 153) ? _c('router-link', {
      attrs: {
        "to": "/mobile-covers"
      }
    }, [_vm._v("(Change phone model)")]) : _vm._e()], 1)])
  }))]), _vm._v(" "), (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !_vm.isSouledOut && !_vm.$parent.isDesktop && _vm.isWishlist) ? _c('div', [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.updateWishlist(_vm.getWishistPrmData, $event)
      }
    }
  }, [(_vm.product && _vm.wishlistItemsIDs && _vm.wishlistItemsIDs[_vm.product.id]) ? _c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/heart-tick.svg",
      "alt": "wishlist selected"
    }
  }) : _c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/heart-add.svg",
      "alt": "add wishlist"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.bannerPDPRating && (this.product.avg_rating >= 1)) ? _c('div', {
    staticClass: "ratingPDP"
  }, [_c('div', [_vm._v(_vm._s(this.product.avg_rating))]), _vm._v(" "), _c('img', {
    staticClass: "starRating",
    attrs: {
      "src": "https://w7.pngwing.com/pngs/566/674/png-transparent-green-star-blue-angle-leaf-thumbnail.png",
      "alt": "starImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pipPDP"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "pdpr"
  }, [_vm._v(_vm._s(_vm.getDataValue(this.product.rating_count)))])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForArtistNameDisplay) ? _c('div', {
    staticClass: "prelative"
  }, [(_vm.product.added_by == 75692) ? _c('a', {
    attrs: {
      "href": "https://www.thesouledstore.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("By "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist)
    }
  })]) : (_vm.product.firstname !== '') ? _c('router-link', {
    attrs: {
      "to": '/artists/' + _vm.product.artist_slug
    }
  }, [(_vm.formattedArtist) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(("By " + _vm.formattedArtist))
    },
    on: {
      "click": function($event) {
        _vm.artistEventHandler(_vm.formattedArtist, _vm.product)
      }
    }
  }) : _vm._e()]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bg-white"
  }, [(_vm.product.variant) ? _c('div', [(_vm.product.stock <= 0) ? _c('div', [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": false
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isColorWebEnable && _vm.product && _vm.product.color_group_details && _vm.product.color_group_details.length) ? _c('div', {
    staticClass: "combo-size-wrapper color-list"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between font-lato"
  }, [(_vm.colorWebHeader) ? _c('h4', {
    staticClass: "font-bold"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.colorWebHeader && _vm.colorWebHeader.description) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex color-list-container"
  }, _vm._l((_vm.product.color_group_details), function(val, colorDetailIndex) {
    return _c('div', {
      key: colorDetailIndex,
      staticClass: "color-parent",
      class: _vm.product.product_slug === val.url_key ? 'active' : ''
    }, [_c('div', {
      staticClass: "color-child",
      style: ({
        backgroundColor: val.color,
      }),
      on: {
        "click": function($event) {
          _vm.prodRedirection(val.url_key)
        }
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.product.prod_type === 6 && _vm.product.options.length) ? _c('div', {
    staticClass: "combo-size-wrapper"
  }, [(_vm.product.options.length > 1) ? _c('h3', {
    staticClass: "font-bold mb-3"
  }, [_vm._v("Please select top and bottom wear size")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.options), function(op, index) {
    return _c('div', {
      key: op.option_id,
      staticClass: "combo-product-inner",
      class: {
        'combo-border-b': index !== _vm.product.options.length - 1
      }
    }, [_c('h4', {
      staticClass: "font-bold"
    }, [_vm._v("\n                    " + _vm._s(op.option_name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "combo-selectbox"
    }, [_c('select', {
      domProps: {
        "value": _vm.selectedComboVariants[op.option_id] ? _vm.selectedComboVariants[op.option_id]['sku'] : ''
      },
      on: {
        "input": function($event) {
          _vm.handleVarientChange($event, op, index)
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "value": ""
      }
    }, [_vm._v("-- Please Select Product --")]), _vm._v(" "), _vm._l((op.variants), function(varnt) {
      return _c('option', {
        key: varnt.variant_id,
        attrs: {
          "disabled": !varnt.stock
        },
        domProps: {
          "value": varnt.sku
        }
      }, [_vm._v(_vm._s(varnt.name))])
    })], 2)]), _vm._v(" "), (!_vm.product.is_common_sizeChart_applicable && _vm.specificComboVarArr[index] && Object.keys(_vm.specificComboVarArr[index]).length) ? _c('div', {
      staticClass: "select-size-wrapper"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between font-lato"
    }, [_c('h4', {
      staticClass: "font-bold"
    }, [_c('span', [_vm._v("\n                          Please select a size.\n                        ")])]), _vm._v(" "), _c('h4', {
      staticClass: "pointer color-red font-bold",
      on: {
        "click": function($event) {
          _vm.getSizeChartData(_vm.specificComboVarArr[index].product_slug, _vm.specificComboVarArr[index].category_id, _vm.specificComboVarArr[index].category, index)
        }
      }
    }, [_vm._v("\n                        Size Chart\n                      ")])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "select-size-inner"
    }, [_c('div', {
      staticClass: "select-size-list scrollx-hide"
    }, _vm._l(((_vm.specificComboVarArr[index] && _vm.specificComboVarArr[index].variant)), function(val, key, index2) {
      return _c('div', {
        key: index2,
        staticClass: "select-sizes pointer",
        class: {
          outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
          selectedSizes: (val.id == _vm.specificComboFormData[index]),
          unselectedSizes: (val.id != _vm.specificComboFormData[index])
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.specificComboFormData[index]),
          expression: "specificComboFormData[index]"
        }],
        staticStyle: {
          "z-index": "-1"
        },
        attrs: {
          "type": "radio",
          "name": "sub_prod",
          "id": (index + "_" + key),
          "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
        },
        domProps: {
          "value": val.id,
          "checked": _vm._q(_vm.specificComboFormData[index], val.id)
        },
        on: {
          "click": function($event) {
            _vm.changevalue(val)
          },
          "__c": function($event) {
            var $$exp = _vm.specificComboFormData,
              $$idx = index;
            if (!Array.isArray($$exp)) {
              _vm.specificComboFormData[index] = val.id
            } else {
              $$exp.splice($$idx, 1, val.id)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        class: {
          'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
        },
        attrs: {
          "for": (index + "_" + key)
        }
      }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || _vm.specificComboVarArr[index]) && _vm.specificComboFormData[index] && val.id == _vm.specificComboFormData[index] && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('div', {
        staticClass: "color-grey text-center font-bold product-stock-left"
      }, [_vm._v("\n                              " + _vm._s(val.stock) + " Left\n                            ")]) : _vm._e()])
    }))]), _vm._v(" "), (_vm.specificComboVarArr[index] && _vm.specificComboVarArr[index].variant && _vm.specificComboVarArr[index].variant.filter(function (itm) { return itm.stock === 0; }).length) ? _c('div', {
      staticClass: "disableclick outOfStockBox product-outstock"
    }, [_c('size-hover', {
      attrs: {
        "parentid": _vm.product.id,
        "proType": _vm.product.prod_type,
        "isOptions": true,
        "sizes": _vm.specificComboVarArr[index] ? [].concat( _vm.specificComboVarArr[index].variant ) : [].concat( _vm.product.variant ),
        "isSouledOut": _vm.isSouledOut
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.specificSizeError && _vm.specificSizeError[index] && !_vm.isComboBreaked) ? _c('div', {
      staticClass: "alert alert-danger product-size-error",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("Please select a size.")]) : _vm._e()])], 1) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (((_vm.product.variant && _vm.product.variant.length || (_vm.product.is_common_sizeChart_applicable && _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd.variant && _vm.commonComboVariantsProd.variant.length)) &&
    (_vm.productSlug !== 'black-panther-proutility-backpack' || (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate))) &&
    (!['black-panther-proutility-backpack'].includes(_vm.productSlug) || (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate)) &&
    (_vm.productSlug !== 'avengers-varsity-jacket' || (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-captain-america-tshirt' || (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-spider-man-tshirt' || (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-black-panther-tshirt' || (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-hulk-tshirt' || (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-thor-tshirt' || (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-iron-man-tshirt' || (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate))
  )) ? _c('div', {
    staticClass: "select-size-wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex justify-content-between font-lato"
  }, [_c('h4', {
    staticClass: "font-bold"
  }, [(_vm.selectedProductVariant.size) ? _c('span', [_vm._v("\n                        Size: " + _vm._s(_vm.selectedProductVariant.size) + "\n                      ")]) : _c('span', [_vm._v("\n                        Please select a size\n                      ")])]), _vm._v(" "), _c('h4', {
    staticClass: "pointer color-red font-bold",
    on: {
      "click": function($event) {
        Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.getSizeChartData(_vm.commonComboVariantsProd.product_slug, _vm.commonComboVariantsProd.category_id, _vm.commonComboVariantsProd.category, null) : _vm.getSizeChartData(_vm.product.product_slug, _vm.product.category_id, _vm.product.category, null)
      }
    }
  }, [_vm._v("Size Chart\n                    ")])]), _vm._v(" "), (_vm.product.prod_type == 3 && _vm.productWiseSizeChartData && _vm.getVarientSizeDetails) ? _c('div', {
    staticClass: "product-size-data color-grey font-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.getVarientSizeDetails)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.prod_type == 3 || Object.keys(_vm.commonComboVariantsProd).length) ? _c('div', [_c('div', {
    staticClass: "select-size-inner"
  }, [_c('div', {
    staticClass: "select-size-list scrollx-hide"
  }, _vm._l((Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.variant : _vm.product.variant), function(val, key, index) {
    return _c('div', {
      key: index,
      staticClass: "select-sizes pointer",
      class: {
        outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
        selectedSizes: (val.id == _vm.selectedProductVariant.id),
        unselectedSizes: (val.id != _vm.selectedProductVariant.id)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formData.prod_id),
        expression: "formData.prod_id"
      }],
      staticStyle: {
        "z-index": "-1"
      },
      attrs: {
        "type": "radio",
        "name": "sub_prod",
        "id": key,
        "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
      },
      domProps: {
        "value": val.id,
        "checked": _vm._q(_vm.formData.prod_id, val.id)
      },
      on: {
        "click": function($event) {
          _vm.changevalue(val)
        },
        "__c": function($event) {
          _vm.formData.prod_id = val.id
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
      },
      attrs: {
        "for": key
      }
    }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || _vm.commonComboVariantsProd) && _vm.selectedProductVariant && val.id == _vm.selectedProductVariant.id && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('div', {
      staticClass: "color-grey text-center font-bold product-stock-left"
    }, [_vm._v("\n                            " + _vm._s(val.stock) + " Left\n                          ")]) : _vm._e()])
  }))]), _vm._v(" "), (_vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock) ? _c('div', {
    staticClass: "disableclick outOfStockBox product-outstock"
  }, [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": true,
      "sizes": Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? [].concat( _vm.commonComboVariantsProd.variant ) : [].concat( _vm.product.variant ),
      "isSouledOut": _vm.isSouledOut
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.sizeError) ? _c('div', {
    staticClass: "alert alert-danger product-size-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Please select a size.")]) : _vm._e()])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.bannerPlaceHolderSnapmintSection && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "snapmint-wrapper"
  }, [_c('div', {
    staticClass: "snap_emi_txt"
  }), _vm._v(" "), _c('span', {
    staticClass: "snapmint_lowest_emi_value",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-snapmint-price": _vm.getMerchantPrice * _vm.formData.quantity,
      "data-snapmint-merchant_id": _vm.merchantId,
      "data-snapmint-page": "products_page"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isExclusive) ? _c('div', {
    staticClass: "membership-discount-wrapper bg-white"
  }, [_c('div', {
    staticClass: "membership-discount-content d-flex align-items-center"
  }, [_c('div', {
    staticClass: "membership-discount-img"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/membership-discount.svg",
      "alt": "Membership Disount"
    }
  })]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "font-lato font-bold"
  }, [_vm._v("\n  \n                    Membership " + _vm._s(Math.floor((parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)) / _vm.getMerchantPrice * 100)) + " % off\n                  ")]), _vm._v(" "), _c('h5', {
    staticClass: "color-grey"
  }, [_vm._v("\n                    Save extra " + _vm._s(_vm.currencySymbol) + _vm._s(parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)) + " on membership"), _c('br'), _vm._v("Free Delivery\n                  ")])])])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForDeliveryDetails) ? _c('div', {
    staticClass: "bg-white delivery-details-wrapper"
  }, [_c('h4', {
    staticClass: "font-lato font-bold"
  }, [_vm._v("Check for the delivery details")]), _vm._v(" "), (!_vm.deliveryDetails.success) ? _c('div', {
    staticClass: "delivery-details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter Pincode",
      "minlength": _vm.pincodeLength,
      "maxlength": _vm.pincodeLength
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keydown": function($event) {
        _vm.postalCodeUpdate($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }, _vm.handlePinCodeInputChange],
      "paste": _vm.handlePaste,
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer delivery-input-check",
    on: {
      "click": _vm.handlePinCodeChange
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.pincodeBtnType) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.showSelectSizeValidationMsg) ? _c('div', {
    staticClass: "error-message mt-2"
  }, [_vm._v("Please select a size")]) : _vm._e(), _vm._v(" "), (_vm.showPincodeValidationMsg) ? _c('div', {
    staticClass: "error-message mt-2"
  }, [_vm._v(_vm._s(_vm.validation.firstError('pincode')))]) : _vm._e(), _vm._v(" "), (_vm.deliveryDetails && _vm.deliveryDetails.success && _vm.deliveryDetails.data) ? _c('div', {
    staticClass: "product-delivery-content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center delivery-content-inner"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/check-tick.svg",
      "alt": "Quality Check"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-delivery-inner"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.pincode))])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer delivery-input-check",
    on: {
      "click": _vm.handlePinCodeChange
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.pincodeBtnType) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "delivery-content-options"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/delivery-icon.svg",
      "alt": "Delivery"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-semibold"
  }, [(_vm.deliveryDetails.data.serviceability && _vm.deliveryDetails.data.max_estimated_days_new) ? _c('div', [_vm._v("Estimated Delivery\n                          "), (_vm.estimatedDeliveryText) ? _c('span', [_vm._v("between " + _vm._s(_vm.getDeliveryDateRange) + ".")]) : _c('span', [_vm._v("by " + _vm._s(_vm.getDeliveryDate) + ".")])]) : _c('div', [_vm._v("Delivery is not serviceable at this Pincode")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/cod-icon.svg",
      "alt": "Cod"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-semibold"
  }, [(_vm.deliveryDetails.data.check_cod) ? _c('div', [_vm._v(_vm._s(_vm.bannerPlaceHolderForCODMessage && _vm.bannerPlaceHolderForCODMessage.tag_text))]) : _c('div', [_vm._v(_vm._s(_vm.bannerPlaceHolderForCODMessage && _vm.bannerPlaceHolderForCODMessage.description))])])])])]) : (_vm.deliveryDetails && _vm.deliveryDetails.data && !_vm.deliveryDetails.success) ? _c('div', {
    staticClass: "mt10"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Delivery is not serviceable at this Pincode")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product.exchange_return_message) ? _c('div', {
    staticClass: "product-return-msg"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex align-items-center return-msg"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/return-icon.svg",
      "alt": "Return"
    }
  }), _vm._v(" "), _c('div', [(_vm.product.exchange_return_message && !_vm.product.exchange_return_message.toLowerCase().includes('know more')) ? _c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.product.exchange_return_message))]) : _c('h5', {
    staticClass: "font-semibold"
  }, _vm._l((_vm.productReturnMsgArr(_vm.product.exchange_return_message)), function(text, index) {
    return _c('span', {
      key: index
    }, [(text && text.toLowerCase() === 'know more') ? _c('span', {
      staticClass: "selectcolor pointer",
      class: !_vm.$parent.isDesktop ? 'dspBlock' : '',
      on: {
        "click": function($event) {
          _vm.returnPolicyKnowMore = !_vm.returnPolicyKnowMore
        }
      }
    }, [_vm._v(_vm._s(text))]) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(text)
      }
    })])
  }))])]), _vm._v(" "), (!_vm.$parent.isDesktop && _vm.returnPolicyKnowMore && _vm.customisedProdFaqs && Object.keys(_vm.customisedProdFaqs).length) ? _c('div', {
    staticClass: "mt10"
  }, [_c('p', {
    staticClass: "fbold mb0"
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('faqsQuestionsListing', {
    attrs: {
      "selectedFaq": _vm.customisedProdFaqs,
      "selectedFaqIndex": 1,
      "callerComp": "customised-prod-faqs"
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-return-wrapper bg-white d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "product-quality-check d-flex align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/quality-check.svg",
      "alt": "Quality Check"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-lato font-bold"
  }, [_vm._v("\n                  Quality Checked\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/genuine-icon.svg",
      "alt": "Genuine Product"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-lato font-bold"
  }, [_vm._v("\n                  Genuine Product\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [(_vm.bannerPlaceHolderForGstInclusiveLabel) ? _c('div', {
    staticClass: "gstInclusiveLabel mb-1"
  }, [_c('span', {
    style: (("color: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_text_color) + "; background: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_color) + ";"))
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForGstInclusiveLabel.tag_text))])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDPExclusivePrice && !_vm.isExclusive && _vm.product.show_exclusive_message) ? _c('div', {
    staticClass: "exclusivePrice mb20",
    style: (_vm.bannerPlaceHolderPDPExclusivePrice.styles)
  }, [_c('p', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.product.exclusive_price) + " " + _vm._s(_vm.bannerPlaceHolderPDPExclusivePrice.text))]), _vm._v(" "), _c('span', {
    staticClass: "knowLink",
    on: {
      "click": function($event) {
        _vm.knowPrice()
      }
    }
  }, [_vm._v("KNOW MORE?")])])]) : _vm._e(), _vm._v(" "), (_vm.product.is_printable) ? _c('div', {
    staticClass: "customization-wrapper mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center customized-input"
  }, [_c('span', {
    staticClass: "customcheckbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "av",
      "id": "accept"
    },
    domProps: {
      "checked": _vm.isCustomizedProdModal || _vm.isCustomizedProd
    },
    on: {
      "change": function($event) {
        _vm.handleCustomization($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "customise-heading pointer",
    on: {
      "click": function($event) {
        _vm.handleCustomization(!(_vm.isCustomizedProdModal || _vm.isCustomizedProd))
      }
    }
  }, [_vm._v("Customise This " + _vm._s(_vm.customisableProductText))]), _vm._v(" "), _c('span', {
    staticClass: "darkblcolor fbold customise-price"
  }, [_vm._v(" (" + _vm._s(_vm.currencyRsToUSD) + " " + _vm._s(_vm.product.extra_price) + " extra)")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product.prod_type === 3 && _vm.product.prod_qty && _vm.product.prod_qty < _vm.stockLeftLimit && (![149, 598].includes(_vm.product.category_id) || ([149, 598].includes(_vm.product.category_id) && (_vm.now < '2019-12-27 00:00:00' || _vm.now > '2019-12-27 01:59:59')))) ? _c('section', {
    staticClass: "product-total-stock total-stock bx1"
  }, [(!(_vm.selectedProductVariant && _vm.selectedProductVariant.stock)) ? _c('span', [_vm._v("\n                  Total " + _vm._s(_vm.product.prod_qty) + " Left\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/product/bhadipa-varta-laugh-ticket') ? _c('section', {
    staticClass: "product-total-stock total-stock bx1"
  }, [_vm._v("\n                  Total " + _vm._s(_vm.product.stock) + " Left\n              ")]) : _vm._e()]), _vm._v(" "), ((_vm.product.variant && _vm.product.variant.length > 0 && _vm.colorOptions && _vm.colorOptions.length > 0)) ? _c('div', {
    staticClass: "bx1 prod-attr-wrapper-mobile"
  }, [_c('p', {
    staticClass: "select-color-header"
  }, [_vm._v("Select Colors")]), _vm._v(" "), (_vm.product.prod_type == 3) ? _c('div', [_c('ul', {
    staticClass: "colorsListMob"
  }, _vm._l((_vm.colorOptions), function(prod) {
    return _c('li', {
      key: prod.product_slug,
      style: ([_vm.currentRouteName === prod.product_slug ? (prod.is_multicolor ? {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        background: prod.product_color
      }) : (prod.is_multicolor ? {
        'border': '2px solid #999696',
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '2px solid #999696',
        background: prod.product_color
      })]),
      on: {
        "click": function($event) {
          _vm.changeColor(prod.product_slug)
        }
      }
    })
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bx1 brd0 mb_mbo"
  }, [(_vm.isBuyNowPopup) ? _c('BuyNowMobile', {
    attrs: {
      "closeBuyNow": _vm.hideBuyNowPopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForAddToCartSizePopup && !_vm.$parent.isDesktop && _vm.isSizePopupActive) ? _c('div', {
    staticClass: "movePopup"
  }, [_c('div', {
    staticClass: "movePopupModalOverlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "movePopup-wrapper py-1 px-3"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse pb-1 my-1",
    on: {
      "click": function($event) {
        _vm.isSizePopupActive = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (((_vm.product.variant && _vm.product.variant.length) || (_vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd.variant && _vm.commonComboVariantsProd.variant.length))) ? _c('div', {
    class: _vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock ? '' : 'pb-2 mb-1'
  }, [_c('div', {
    staticClass: "d-flex justify-content-between font-lato"
  }, [_c('h4', {
    staticClass: "font-bold"
  }, [_vm._v("\n                    Please select a size\n                  ")]), _vm._v(" "), _c('h4', {
    staticClass: "pointer color-red font-bold",
    on: {
      "click": function($event) {
        _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length ? _vm.getSizeChartData(_vm.commonComboVariantsProd.product_slug, _vm.commonComboVariantsProd.category_id, _vm.commonComboVariantsProd.category, null) : _vm.getSizeChartData(_vm.product.product_slug, _vm.product.category_id, _vm.product.category, null)
      }
    }
  }, [_vm._v("Size Chart\n                  ")])]), _vm._v(" "), (_vm.product.prod_type == 3 || _vm.commonComboVariantsProd) ? _c('div', {
    staticClass: "select-size-wrapper bottom-select-size"
  }, [_c('div', {
    staticClass: "select-size-inner d-flex"
  }, _vm._l(((Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.variant : _vm.product.variant)), function(val, key, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "select-sizes pointer",
      class: {
        outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
        selectedSizes: (val.id == _vm.selectedProductVariant.id),
        unselectedSizes: (val.id != _vm.selectedProductVariant.id)
      }
    }, [_c('input', {
      staticStyle: {
        "z-index": "-1"
      },
      attrs: {
        "type": "radio",
        "name": "sub_prod",
        "id": key,
        "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
      },
      domProps: {
        "value": val.id
      },
      on: {
        "change": function($event) {
          _vm.changevalue(val)
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
      },
      attrs: {
        "for": key
      }
    }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || (_vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length)) && _vm.selectedProductVariant && val.id == _vm.selectedProductVariant.id && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('section', {
      staticClass: "color-grey text-center font-bold product-stock-left"
    }, [_vm._v("\n                          " + _vm._s(val.stock) + " Left\n                        ")]) : _vm._e()])])
  })), _vm._v(" "), (_vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock) ? _c('div', {
    staticClass: "disableclick outOfStockBox"
  }, [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": true,
      "sizes": _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length ? [].concat( _vm.commonComboVariantsProd.variant ) : [].concat( _vm.product.variant ),
      "isSouledOut": _vm.isSouledOut,
      "isMoveToCartPopup": true
    }
  })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.authStatus && _vm.product && _vm.product.stock <= 0 && _vm.product.prod_qty <= 0 && _vm.getVoteCardDetails && _vm.getVotedProductText) ? _c('div', {
    staticClass: "product-vote-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.productVoted) ? _c('span', [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/vote.png",
      "alt": "Vote image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer color-red text-underline",
    on: {
      "click": _vm.voteSoldedOutProduct
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getVoteCardDetails.tag_text) + " ")]), _vm._v(" " + _vm._s(_vm.getVoteCardDetails.description) + "\n              ")]) : _c('span', [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/round_tick.png",
      "alt": "Voted image"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(_vm.getVotedProductText.description) + "\n                ")])])])], 1) : _vm._e(), _vm._v(" "), ((!_vm.productZoomMobile) && (!_vm.isBuyNowPopup)) ? _c('div', {
    staticClass: "mbstickyfooter addcart-btn-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.prod_id),
      expression: "formData.prod_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "prod_id",
      "id": "prod_id"
    },
    domProps: {
      "value": (_vm.formData.prod_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.prod_id = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.prod_type),
      expression: "formData.prod_type"
    }],
    attrs: {
      "type": "hidden",
      "name": "prod_type",
      "value": "product.prod_type"
    },
    domProps: {
      "value": (_vm.formData.prod_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.prod_type = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "product-price-wrapper d-flex align-items-center",
    class: !_vm.bannerPlaceHolderForGstInclusiveLabel ? 'mb20' : ''
  }, [(_vm.product.price) ? _c('div', {
    staticClass: "font-lato"
  }, [(Math.round(_vm.product.spl_price) || (_vm.isExclusive && Math.round(_vm.product.exclusive_price))) ? _c('span', [_c('span', {
    staticClass: "font-bold offer-price"
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.isExclusive ? _vm.product.exclusive_price && parseInt(_vm.product.exclusive_price) : _vm.product.spl_price && parseInt(_vm.product.spl_price)) + "  \n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "actual-price"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price)))])]) : (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(_vm.productSlug)) ? _c('span', {
    staticClass: "only-price font-bold"
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.$parent.currencyFormate(parseInt(_vm.product.price))))]) : _c('span', {
    staticClass: "only-price font-bold",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(parseInt(_vm.product.price)) + "\n                  ")]), _vm._v(" "), (_vm.product && _vm.product.spl_price && !_vm.isExclusive) ? _c('span', {
    staticClass: "discount-price font-bold"
  }, [(_vm.isNonExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(parseInt(((_vm.product && _vm.product.price) - (_vm.isExclusive ? (_vm.product && _vm.product.exclusive_price) : (_vm.product && _vm.product.spl_price))) / (_vm.product && _vm.product.price) * 100)) + "% " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF') + "\n                    ")]) : _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price) - parseInt((_vm.isExclusive ? (_vm.product && _vm.product.exclusive_price) : (_vm.product && _vm.product.spl_price)))) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF'))])]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.price && _vm.product.exclusive_price && _vm.isExclusive) ? _c('span', {
    staticClass: "discount-price font-bold"
  }, [(_vm.isExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(parseInt(((_vm.product && _vm.product.price) - (_vm.product && _vm.product.exclusive_price)) / (_vm.product && _vm.product.price) * 100)) + "% " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings'))]) : _c('span', {
    staticClass: "mdiscount"
  }, [_vm._v(_vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " " + _vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)))])]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.mrp && parseInt(_vm.product.mrp) > 0 && _vm.showMrpOnPdp) ? _c('div', {
    staticClass: "mrp-price-text"
  }, [_vm._v("MRP Rs. " + _vm._s(parseInt(_vm.product.mrp)) + " " + _vm._s(_vm.showMrpOnPdp.tag_text))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.goToCart || (_vm.product.prod_type === 6 && _vm.isComboProductAddedInCart) || (_vm.isTssCorpProduct && _vm.isTssCorporateProductAddedInCart)) ? _c('router-link', {
    staticClass: "cart-btn",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    attrs: {
      "to": '/cart'
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToCartClick($event)
      }
    }
  }, [_vm._v("Go to Cart\n              ")]) : ((_vm.isSouledOut || _vm.isOutOfStock) && !_vm.isComboBreaked) ? _c('button', {
    staticClass: "cart-btn outofstock",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Out of Stock\n              ")]) : (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !['camouflage-olive-hoodie', 'black-panther-proutility-backpack', 'black-panther-proutility-backpack', 'avengers-varsity-jacket', 'mumbai-indians-fan-rohit-45-jersey', 'anniversary-collection-captain-america-tshirt', 'anniversary-collection-spider-man-tshirt', 'anniversary-collection-black-panther-tshirt', 'anniversary-collection-hulk-tshirt', 'anniversary-collection-thor-tshirt', 'anniversary-collection-iron-man-tshirt'].includes(_vm.productSlug) || (_vm.productSlug === 'camouflage-olive-hoodie' && _vm.now >= _vm.endDate && _vm.isExclusive) ||
    (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate) ||
    (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate)) ||
    (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate)) ||
    (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate)
  ) ? _c('button', {
    staticClass: "cart-btn",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    style: ([_vm.cartSaleStyle]),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.checkDisabled() || (this.product.prod_type === 6 && _vm.selectedComboVariants && Object.keys(_vm.selectedComboVariants).length <= 0)
    },
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.cartSaleStyle && _vm.cartSaleStyle.text ? _vm.cartSaleStyle.text : 'Add to Cart') + "\n                ")]) : (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && (_vm.productSlug === 'camouflage-olive-hoodie' && (!_vm.isExclusive || (_vm.isExclusive && _vm.now < _vm.endDate))) ||
    (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now < _vm.endDate) ||
    (_vm.productSlug === 'black-panther-proutility-backpack' && (_vm.now < _vm.exclusiveDate) || (_vm.now < _vm.endDate && _vm.endDate != _vm.exclusiveDate && !_vm.isExclusive)) ||
    (_vm.productSlug === 'batman-3d-logo-tshirt' && (_vm.now < _vm.exclusiveDate) || (_vm.now < _vm.endDate && _vm.endDate != _vm.exclusiveDate && !_vm.isExclusive)) ||
    (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now <= _vm.endDate)
  ) ? _c('button', {
    staticClass: "cart-btn",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Add to Cart\n                ")]) : _vm._e(), _vm._v(" "), (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !_vm.isSouledOut && !_vm.$parent.isDesktop && !_vm.bannerPlaceHolderForBuyNow && _vm.product.prod_type !== 6 && !_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-info btn-block pointer",
    staticStyle: {
      "border-radius": "3px",
      "background-color": "teal"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.buyNowHandler()
      }
    }
  }, [_vm._v("BUY NOW\n                ")])]) : _vm._e(), _vm._v(" "), (!_vm.enableActionBoton) ? _c('div', {
    staticClass: "membership_action_Btn"
  }, [(_vm.isWishlist) ? _c('button', {
    staticClass: "btn pointer membership_Btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.AddMembership()
      }
    }
  }, [_c('img', {
    staticClass: "ml-2",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/Vector.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "membership_Btn_text"
  }, [_vm._v("Purchase membership to access")])]) : _vm._e()]) : _vm._e()], 1)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', [(_vm.bannerPlaceHolderTSSPoints && _vm.bannerPlaceHolderTSSPoints.tss_points && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-12 return-msg-pdp tss-points-message-pdp d-flex justify-content-start align-items-center"
  }, [_c('img', {
    staticClass: "tss-points-icon",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/public/theSoul/images/appIcons/ic_tssMoney1@3x.png",
      "alt": "The Souled Store Points"
    }
  }), _vm._v(" "), _c('p', {}, [_c('span', {
    style: ({
      color: _vm.bannerPlaceHolderTSSPoints.banner_text_color
    })
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.prev_text))]), _vm._v(" "), _c('span', {
    staticClass: "tss-points"
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.tss_points))]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.bannerPlaceHolderTSSPoints.banner_text_color
    })
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.after_text))])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "accordiontabs",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [(_vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boy Shorts' || _vm.product.category === 'Women Hipster Underwear')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingThree"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed cusrev",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    },
    on: {
      "click": _vm.productDescription
    }
  }, [_vm._v("\n                Customer Reviews\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseThree",
      "role": "tabpanel",
      "aria-labelledby": "headingThree"
    }
  }, [(_vm.productPerData && _vm.productPerData.length) ? _c('div', {
    staticClass: "card-block pg-block"
  }, _vm._l((_vm.productPerData), function(val, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category.indexOf(val.category) !== -1) ? _c('div', {
      staticClass: "pg-col"
    }, [_c('span', [_vm._v(_vm._s(val.title))]), _vm._v(" "), _c('div', {
      staticClass: "progress progress-danger active",
      attrs: {
        "aria-valuenow": "12"
      }
    }, [_c('div', {
      staticClass: "bar",
      style: ('width:' + val.percentage + '%')
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-right prg-text"
    }, [_vm._v(_vm._s(val.text) + " (" + _vm._s(val.percentage) + "%)")])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.reviewsData && _vm.reviewsData.length) ? _c('div', {
    staticClass: "scrolldiv"
  }, _vm._l((_vm.shuffle(_vm.reviewsData)), function(rew, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category.indexOf(rew.category) !== -1) ? _c('div', {
      staticClass: "cus-review"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(rew.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name-age"
    }, [_c('span', [_vm._v(_vm._s(rew.name))]), (rew.age) ? _c('span', [_vm._v(" | Age - " + _vm._s(rew.age) + " years")]) : _vm._e()])]) : _vm._e()])
  })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.product.add_desc) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne",
      "aria-expanded": _vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boys Shorts' || _vm.product.category === ' Women Hipster Underwear') ? 'false' : 'true',
      "aria-controls": "collapseOne"
    },
    on: {
      "click": _vm.productDetails
    }
  }, [_vm._v("\n                Product Details\n              ")])])]), _vm._v(" "), _c('div', {
    class: _vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boys Shorts' || _vm.product.category === ' Women Hipster Underwear') ? 'collapse' : 'collapse show',
    attrs: {
      "id": "collapseOne",
      "aria-expanded": "false",
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.add_desc)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.product.short_desc) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingTwo"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    },
    on: {
      "click": _vm.productDescription
    }
  }, [_vm._v("\n                Product Description\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "role": "tabpanel",
      "aria-labelledby": "headingTwo"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.short_desc)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.product.user_description) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingArtist"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseArtist",
      "aria-expanded": "false",
      "aria-controls": "collapseArtist"
    }
  }, [_vm._v("\n                Artist's Details\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseArtist",
      "role": "tabpanel",
      "aria-labelledby": "headingArtist"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.user_description)
    }
  })])])])]) : _vm._e()]), _vm._v(" "), (_vm.bannerPlaceHolderReviewSection && _vm.product.avg_product_rating > 0) ? _c('div', [_c('ReviewModal', {
    attrs: {
      "avgRating": _vm.product.avg_product_rating,
      "productId": this.product.id
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), (!_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "bg-white recommended-products"
  }, [(_vm.showFrequentlyBoughtListing && _vm.frequentlyBoughtPdpListing && _vm.frequentlyBoughtPdpListing.data && _vm.frequentlyBoughtPdpListing.data.length && _vm.product.images) ? _c('div', {
    staticClass: "pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showFrequentlyBoughtListing.model_position)
    })
  }, [_c('h2', {
    staticClass: "font-bold font-lato"
  }, [_vm._v(_vm._s(_vm.showFrequentlyBoughtListing.tag_text || 'Frequently Bought Products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.frequentlyBoughtPdpListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artistname,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.frequentlyBoughtPdpListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm
      },
      nativeOn: {
        "click": function($event) {
          _vm.frequentlyBoughtPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.productRecommData && Object.keys(_vm.productRecommData).length) ? _c('div', {
    attrs: {
      "id": "crossSellProducts"
    }
  }, _vm._l((_vm.productRecommData), function(widget, widgetKey, index) {
    return _c('div', {
      key: index
    }, [(widget && widget.length && _vm.bannerPlaceHolderForProductRecommData && _vm.bannerPlaceHolderForProductRecommData.includes(widgetKey)) ? _c('div', [_c('h2', {
      staticClass: "font-bold font-lato"
    }, [_vm._v(_vm._s(_vm.productRecommTitleMapping && _vm.productRecommTitleMapping[widgetKey]))]), _vm._v(" "), _c('carousel', {
      attrs: {
        "perPage": 2.5,
        "navigationEnabled": true,
        "paginationEnabled": false,
        "navigationNextLabel": " ",
        "navigationPrevLabel": " ",
        "autoplay": false,
        "perPageCustom": [
          [480, 2.5],
          [768, 3],
          [1200, 4]
        ]
      }
    }, _vm._l((widget), function(prm, index) {
      return _c('slide', {
        key: prm.id,
        staticClass: "col-md-3 col-6"
      }, [_c('div', {
        staticClass: "alsoavail vueCaraSlidr"
      }, [_c('img-block', {
        attrs: {
          "parry": prm.imageUrl,
          "position": index,
          "isExclusive": _vm.isExclusive,
          "index": index,
          "urlKey": prm.product_slug,
          "productTitle": prm.product,
          "productPrice": prm.price,
          "exclusivePrice": prm.exclusive_price,
          "jitValue": prm.jitValue,
          "productCat": prm.artist,
          "pstock": prm.stock,
          "spprice": prm.spl_price,
          "listCat": prm.category && prm.category[0],
          "genderType": prm.gender_type,
          "pclass": 'prd' + prm.id + prm.category + 'img',
          "product": prm,
          "isStockConfig": prm.prod_qty,
          "scrollToProduct": _vm.scrollNow,
          "prodType": prm.prod_type,
          "togglePopup": _vm.togglePopup,
          "showImageBlurSoldOutDesign": true
        }
      })], 1)])
    }))], 1) : _vm._e()])
  })) : (_vm.showSimilarProductDetails && _vm.crossSellItems && _vm.crossSellItems.length > 0) ? _c('div', {
    staticClass: "pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showSimilarProductDetails.model_position)
    }),
    attrs: {
      "id": "crossSellProducts"
    }
  }, [_c('h2', {
    staticClass: "font-bold font-lato"
  }, [_vm._v(_vm._s(_vm.showSimilarProductDetails.tag_text || 'Similar Products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.crossSellItems), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artistname,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.crossSellItems.length,
        "showImageBlurSoldOutDesign": true,
        "callerComp": _vm.crossSellName || 'Similar Products',
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.crossSellPdpListing && _vm.crossSellPdpListing.data && _vm.crossSellPdpListing.data.length && _vm.crossSellingPdpDetails) ? _c('div', {
    staticClass: "pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.crossSellingPdpDetails.model_position)
    }),
    attrs: {
      "id": "crossSellPdpListing"
    }
  }, [_c('h2', {
    staticClass: "font-bold font-lato"
  }, [_vm._v(_vm._s(_vm.crossSellingPdpDetails.tag_text || 'You may also like'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.crossSellPdpListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artistname,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.crossSellPdpListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPersonalizedWidgetListing && _vm.personalizedWidgetListing && _vm.personalizedWidgetListing.data && _vm.personalizedWidgetListing.data.length && _vm.authStatus) ? _c('div', {
    staticClass: "pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showPersonalizedWidgetListing.model_position)
    }),
    attrs: {
      "id": "crossSellPdpListing"
    }
  }, [_c('h2', {
    staticClass: "font-bold font-lato"
  }, [_vm._v(_vm._s(_vm.showPersonalizedWidgetListing.tag_text || 'Personalized products 123'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.personalizedWidgetListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artistname,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.personalizedWidgetListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.prview) ? _c('product-view', {
    attrs: {
      "isDesktop": this.$parent.isDesktop,
      "imgArray": _vm.product.images,
      "videoUrl": _vm.prviewImage,
      "activeImg": _vm.magActiveimg
    },
    on: {
      "close": function($event) {
        _vm.prview = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isImageModal) ? _c('sizeimage-modal', {
    attrs: {
      "imageModalData": _vm.imageModalData
    },
    on: {
      "close": function($event) {
        _vm.isImageModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "productAdded"
  }, [_vm._v("Product has been added to cart.")]), _vm._v(" "), (_vm.isNotifyVisible) ? _c('exclusive-modal', {
    attrs: {
      "addExclusive": _vm.addExclusive,
      "togglePopup": _vm.togglePopup,
      "exclusiveAdded": _vm.exclusiveAdded,
      "removeExcFromCart": _vm.removeExcFromCart,
      "memberSavings": _vm.product.price && _vm.product.exclusive_price && parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCustomizedProdModal && _vm.imageModalData && Object.keys(_vm.imageModalData).length) ? _c('customized-prod-modal', {
    attrs: {
      "customizedProdData": _vm.imageModalData,
      "confirmCustomization": _vm.confirmCustomization,
      "prodPrintName": _vm.print_name,
      "prodPrintNumber": _vm.print_number,
      "artistSlug": _vm.product.artist_slug
    },
    on: {
      "close": function($event) {
        _vm.isCustomizedProdModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f407f5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productdetailsmweb.vue
// module id = 2482
// module chunks = 13